// Frittstående objektliste-panel (poppet ut til egen skjerm). Kobler egen
// datafeed (WS, cookie-autentisert) og viser levende spor. Klikk på en rad
// kringkaster «focus» via SyncBus → hovedvinduets kart flyr dit.
import type { Track } from '@skade/contracts';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { BFT_SELF_ID, maalingsLinje, type PlacedUnit } from '../tools/units.js';

export function mountRosterPanel(root: HTMLElement, feed: Feed, sync: SyncBus, title = 'Objektliste'): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';

  const wrap = document.createElement('div');
  wrap.className = 'standalone-panel';
  const head = document.createElement('div');
  head.className = 'standalone-head';
  head.append(txt('brand', 'SKADE'), txt('standalone-title', title));
  const count = txt('roster-count', '0');
  head.append(count);
  const list = document.createElement('div');
  list.className = 'roster-list standalone-list';
  wrap.append(head, list);
  root.append(wrap);

  let tracks: Track[] = [];
  let sharedUnits: PlacedUnit[] = [];

  const render = () => {
    count.textContent = String(tracks.length + sharedUnits.length);
    list.innerHTML = '';
    if (!tracks.length && !sharedUnits.length) {
      list.append(txt('roster-empty', 'Ingen objekter ennå'));
      return;
    }
    for (const t of tracks) {
      list.append(row(t.label, t.kind, t.affiliation, () => sync.post({ type: 'focus', lon: t.lon, lat: t.lat, label: t.label })));
    }
    const naa = Date.now();
    for (const u of sharedUnits) {
      const aff = { F: 'friend', H: 'hostile', N: 'neutral', U: 'unknown' }[u.sidc[1]] ?? 'unknown';
      // Samme krav som i hovedvinduets objektliste: en BFT-måling skal ikke stå
      // som «enhet» uten alder. Dette vinduet får enhetene over hubbens fanout,
      // og alderen regnes derfor mot MOTTAKERENS klokke — som er den som gjelder
      // for om posisjonen kan brukes til noe her.
      const kind = u.id === BFT_SELF_ID && u.tsMs !== undefined
        ? `BFT-posisjon · ${maalingsLinje(u.tsMs, naa)}`
        : 'enhet';
      list.append(row(u.label, kind, aff, () => sync.post({ type: 'focus', lon: u.lon, lat: u.lat, label: u.label })));
    }
  };

  feed.onTracks((t) => { tracks = t; render(); });
  // Enheter plassert i hovedvinduet kommer hit via hubbens collab-fanout.
  feed.onCollab?.((m) => {
    if (m.kind === 'units' && m.units) { sharedUnits = m.units as PlacedUnit[]; render(); }
  });
  feed.start();
  render();
}

function row(label: string, kind: string, aff: string, onClick: () => void): HTMLElement {
  const r = document.createElement('button');
  r.className = `roster-row aff-${aff}`;
  const dot = document.createElement('span'); dot.className = 'roster-dot';
  r.append(dot, txt('roster-name', label), txt('roster-kind', kind));
  r.onclick = onClick;
  return r;
}
function txt(cls: string, text: string): HTMLElement {
  const e = document.createElement('span');
  e.className = cls;
  e.textContent = text;
  return e;
}
